import { authMethodConfigApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE = createNamedActions(
  'companyAuthMethodConfig',
  {
    GET_AUTH_METHOD_CONFIG: 'GET_AUTH_METHOD_CONFIG',
    UPDATE_AUTH_METHOD_CONFIG: 'UPDATE_AUTH_METHOD_CONFIG',
  },
);

export const getCompanyAuthMethodConfigAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      const { data } = await authMethodConfigApi.getAuthMethodConfig({ companyId });

      return dispatch({
        type: COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE.GET_AUTH_METHOD_CONFIG,
        payload: data,
      });
    },
);

export const updateCompanyAuthMethodConfigAction = catchAsyncActionError(
  ({ companyId, ...params }) =>
    async dispatch => {
      const { data } = await authMethodConfigApi.updateAuthMethodConfig({ companyId, ...params });

      return dispatch({
        type: COMPANY_AUTH_METHOD_CONFIG_ACTION_TYPE.UPDATE_AUTH_METHOD_CONFIG,
        payload: data,
      });
    },
);
